import React from 'react';
export function Footer() {
  return <footer className="py-6 md:py-12 px-4 md:px-12 border-t border-border text-center relative z-10" data-id="element-79">
      <div className="font-display text-[1.1rem] md:text-[1.5rem] tracking-[4px] bg-gradient-to-r from-gold to-cyan text-gradient mb-3 md:mb-5" data-id="element-80">
        CREADOR MILLONARIO · IA
      </div>
      <div className="flex justify-center gap-4 md:gap-8 flex-wrap mb-3 md:mb-5" data-id="element-81">
        {['Política de Privacidad', 'Términos de Uso', 'Contacto'].map((link, i) => <a key={i} href="#" className="text-[0.7rem] md:text-[0.8rem] text-text-muted no-underline tracking-[1px] transition-colors hover:text-gold" data-id="element-82">
              {link}
            </a>)}
      </div>
      <p className="text-[0.65rem] md:text-[0.75rem] text-text-ghost tracking-[1px] leading-[1.7]" data-id="element-83">
        © 2025 La Mentalidad del Creador Millonario con IA · Todos los derechos
        reservados
        <br data-id="element-84" />
        Este producto es de uso personal e intransferible. Los resultados pueden
        variar.
      </p>
    </footer>;
}